import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
export const ICON_REFERENCE_TO_ICON_TYPE = {
    pro: $icon('custom-perplexity-copilot'),
    collection: $icon('folders'),
    research: $icon('telescope'),
    labs: $icon('table-plus'),
    comet_login: $icon('custom-brand-comet'),
    invite: $icon('mail'),
    app: $icon('layout-collage'),
    slides: $icon('presentation'),
    document: $icon('file'),
    plaintext: $icon('file'),
    canvas: $icon('file'),
    advanced_models: $icon('cpu'),
    map_pin: $icon('map-pin'),
    computer: $icon('custom-computer'),
    org_invite: $icon('building'),
};
//# sourceMappingURL=icons.js.map